export interface VendorUser {
  vendorId: string
  email: string
  firstName: string
  lastName: string
  avatarUrl: string
  roleId: string
}

export const vendorUserConverter: firebase.firestore.FirestoreDataConverter<VendorUser> = {
  toFirestore: (vendorUser) => {
    return {
      vendorId: vendorUser.vendorId,
      email: vendorUser.email,
      firstName: vendorUser.firstName,
      lastName: vendorUser.lastName,
      avatarUrl: vendorUser.avatarUrl,
      roleId: vendorUser.roleId
    }
  },
  fromFirestore: (snapshot, options) => {
    const data = snapshot.data(options)
    return {
      vendorId: data.vendorId,
      email: data.email,
      firstName: data.firstName,
      lastName: data.lastName,
      avatarUrl: data.avatarUrl,
      roleId: data.roleId
    }
  }
}
